import React from 'react';
import { DocumentTitle } from '@atlassian/jira-global-document-title/src/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { useBacklogSelector } from '../../state/index.tsx';
import { getName } from '../../state/selectors/app/index.tsx';
import messages from './messages.tsx';

export default function BacklogDocumentTitle() {
	const intl = useIntl();
	const boardName = useBacklogSelector(getName);

	return (
		<DocumentTitle
			title={intl.formatMessage(messages.pageTitle, {
				boardName,
			})}
		/>
	);
}
